import GenericModel from "./generic";

const Model = GenericModel.extend({
  namedAttributes: {
    active: Boolean,
  },
  defaults: {
    active: true,
  },
});

export { Model as default };
